import { useCallback, useState } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { reportErrorToLogFetch } from 'academy-common-lib/utils/errorUtils';
import { usePracticalExercisePortalId } from '../practicalExerciseQueries';
import { ContactUsLink } from '../../../components/ContactUsLink';
import { Metrics } from '../../../Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
const PracticalExerciseStartButton = ({
  contentId,
  exerciseTypeLabel = 'none',
  lessonId,
  trackId,
  onStartClick,
  onProvisioningChange,
  use = 'primary',
  label
}) => {
  const [loading, setLoading] = useState(false);
  const {
    getOrCreatePortal,
    pollUntilProvisioned,
    portalIdLoading,
    isSimulationExercise,
    isSimulationGateLoading
  } = usePracticalExercisePortalId(Number(contentId), trackId);
  const setIsProvisioning = useCallback(value => onProvisioningChange === null || onProvisioningChange === void 0 ? void 0 : onProvisioningChange(value), [onProvisioningChange]);
  const handleOnClick = async () => {
    try {
      var _getOrCreatePortal, _portalResponse$data;
      setLoading(true);
      if (!isSimulationExercise) {
        await (onStartClick === null || onStartClick === void 0 ? void 0 : onStartClick());
        return;
      }
      const portalResponse = await ((_getOrCreatePortal = getOrCreatePortal()) === null || _getOrCreatePortal === void 0 ? void 0 : _getOrCreatePortal.then(response => {
        Metrics.counter('exercise-content-mutation', {
          action: 'practical-exercise-portal-get-or-created',
          exerciseType: exerciseTypeLabel
        }).increment();
        return response;
      }).catch(error => {
        Metrics.counter('exercise-mutation-call-error', {
          action: 'practical-exercise-portal-get-or-create-error',
          exerciseType: exerciseTypeLabel
        }).increment();
        reportErrorToLogFetch({
          loggingTitle: 'Practical Exercise Portal Get or Create Error',
          action: 'practical-exercise-portal-get-or-create-error',
          error,
          additionalData: {
            contentId,
            lessonId,
            trackId
          }
        });
        FloatingAlertStore.addAlert({
          type: 'danger',
          message: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "learningCenter.practicalExercise.portalCreateError",
            options: {
              contactUsLink: /*#__PURE__*/_jsx(ContactUsLink, {})
            }
          })
        });
        return null;
      }));
      if (!portalResponse) {
        return;
      }
      const portalId = (_portalResponse$data = portalResponse.data) === null || _portalResponse$data === void 0 || (_portalResponse$data = _portalResponse$data.createPortal) === null || _portalResponse$data === void 0 ? void 0 : _portalResponse$data.portalId;
      setIsProvisioning(true);
      const provisioningResult = await pollUntilProvisioned(contentId).then(() => {
        Metrics.counter('exercise-content-mutation', {
          action: 'practical-exercise-portal-provisioning-success',
          exerciseType: exerciseTypeLabel
        }).increment();
        return true;
      }).catch(error => {
        Metrics.counter('exercise-mutation-call-error', {
          action: 'practical-exercise-portal-provisioning-error',
          exerciseType: exerciseTypeLabel
        }).increment();
        reportErrorToLogFetch({
          loggingTitle: 'Practical Exercise Portal Provisioning Error',
          action: 'practical-exercise-portal-provisioning-error',
          error,
          additionalData: {
            contentId,
            lessonId,
            trackId
          }
        });
        FloatingAlertStore.addAlert({
          type: 'danger',
          message: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "learningCenter.practicalExercise.portalProvisioningError",
            options: {
              contactUsLink: /*#__PURE__*/_jsx(ContactUsLink, {})
            }
          })
        });
        return null;
      });
      if (!provisioningResult) {
        return;
      }
      await (onStartClick === null || onStartClick === void 0 ? void 0 : onStartClick(portalId));
    } catch (error) {
      reportErrorToLogFetch({
        loggingTitle: 'Practical Exercise Start Click Unhandled Error',
        action: 'practical-exercise-start-click-unhandled-error',
        error,
        additionalData: {
          contentId,
          lessonId,
          trackId
        }
      });
    } finally {
      setLoading(false);
      setIsProvisioning(false);
    }
  };
  return /*#__PURE__*/_jsx(LoadingButton, {
    "data-test-id": "practical-exercise-start-button",
    loading: loading || portalIdLoading || isSimulationGateLoading,
    onClick: () => void handleOnClick(),
    use: use,
    children: label
  });
};
export default PracticalExerciseStartButton;